import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteSvg, DownloadSvg, EditSvg } from '../../assets/svg';
import logo_icon from '../../assets/images/Logo/Bharat-Darshan-Logo.png';
import * as OperatorImageActions from '../../redux/actions/operatorImageAction.js';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { DeepSearchSpace, DataTableCustomStyles } from '../../utils/common-function/index.js';
import * as XLSX from 'xlsx';

const DisplayOperatorImages = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isLoading } = useSelector(state => state?.dashboard);
    const { operatorData, operatorImageData } = useSelector(state => state?.operatorImageReducer);
    const [operator, setOperator] = useState({ _id: '', name: '' });

    const [searchText, setSearchText] = useState('');
    const handleSearch = (e) => setSearchText(e.target.value);
    let filteredData = DeepSearchSpace(operatorImageData, searchText);

    //* DataTable Columns
    const columns = [
        { name: 'S.No.', selector: row => filteredData.indexOf(row) + 1, width: '80px' },
        { name: 'Operator', selector: row => row?.servicesTypeDetails?.name },
        ...(operator && operator.name === 'Electricity' ? [{ name: 'City', selector: row => row.city, }] : []),
        { name: 'Operator Name', selector: row => row?.OperatorName, width: '250px' },
        { name: 'Operator Code', selector: row => row?.OperatorCode },
        { name: 'Max.Amt', selector: row => row?.maxAmount },
        { name: 'Min.Amt', selector: row => row?.minAmount },
        { name: 'Operator Icon', cell: row => <img src={row?.operatorImage ? row?.operatorImage : logo_icon} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
        {
            name: 'Action',
            cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
                <div onClick={() => navigate('/edit-operator-images', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
                {/* <div style={{ cursor: "pointer" }}><DeleteSvg /></div> */}
            </div >,
            width: "180px"
        },
    ];

    //! Download
    const handleExportToExcel = () => {
        const filteredDataForExcel = filteredData.map((item, index) => ({
            "Sl. No.": index + 1,
            City: item.city,
            "Operator Type": item.servicesTypeDetails.name,
            "Operator Name": item.OperatorName,
            "Operator Code": item.OperatorCode,

        }));

        const ws = XLSX.utils.json_to_sheet(filteredDataForExcel);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Operators');
        XLSX.writeFile(wb, 'Operators.xlsx');
    };

    useEffect(() => {
        //! Dispatching API for Get Operator
        dispatch(OperatorImageActions.getOperator());
    }, []);

    useEffect(() => {
        //! Dispatching API for Get Operator
        dispatch(OperatorImageActions.getOperatorImages({ operator }));
    }, [operator]);

    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                {
                    operatorImageData &&
                    <>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
                            <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Operator Image</div>

                            <div style={{ display: "flex", gap: "30px", alignItems: "center" }}>
                                <div onClick={() => handleExportToExcel()} style={{ color: "#000", fontSize: "1rem", textDecoration: "none", display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }} >
                                    <div style={{ fontSize: "16px", fontWeight: "600", color: '#667284' }}>Download</div>
                                </div>

                                <div onClick={() => navigate('/add-operator-images', { state: { stateData: {} } })} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "2px 5px", borderRadius: "5px", display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                                    <div style={{ fontSize: "15px" }}>Add</div>
                                    <div style={{ fontWeight: "bold", fontSize: "18px" }}>+</div>
                                </div>
                            </div>
                        </div>

                        <div style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
                            <select value={operator?._id} onChange={(e) => setOperator(operatorData.find(item => item._id === e.target.value))} style={{ padding: '5px 10px', borderRadius: '5px', border: '1px solid #ccc', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '250px', fontSize: '15px', fontFamily: 'Philosopher', outline: 'none', }} >
                                <option value="" selected>Choose Operator</option>
                                {operatorData?.map((item, index) => <option value={item._id} key={index}>{item?.name}</option>)}
                            </select>

                            <input type='search' value={searchText} onChange={handleSearch} placeholder='Search your data...' style={{ padding: '5px 10px', borderRadius: '5px', border: '1px solid #ccc', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '250px', fontSize: '15px', fontFamily: 'Philosopher', outline: 'none', }} />
                        </div>
                    </>
                }

                {isLoading ?
                    <div style={{ color: "black", textAlign: "center", minHeight: "400px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", fontFamily: 'Philosopher', animation: 'rotation 2s infinite linear' }}>
                        <img src={logo_icon} style={{ height: "100px", height: "100px" }} alt="" />
                    </div> :
                    <div>
                        <DataTable
                            columns={columns}
                            data={filteredData?.sort((a, b) => new Date(b.created) - new Date(a.created))}
                            pagination
                            customStyles={DataTableCustomStyles}
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                            paginationComponentOptions={{ rowsPerPageText: 'Rows Per Page :' }}
                        />
                    </div>}
            </div>
        </>
    )
}

export default DisplayOperatorImages;